import React from 'react'
import Wrapper from '../Wrapper'


let Auth = (props) => {
    let {children} = props
    return (
        <Wrapper renderButtonNav = {false} renderFooterTop = {true}>
            <div className="container content">
                {children}
            </div>
        </Wrapper>
    )
}

export default Auth


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/Auth/index.js